<app-modal-filler-atom
  (click)="close()"
  [index]="(index$ | async) ?? 0"
></app-modal-filler-atom>
<div
  class="fixed left-0 right-0 mx-auto max-h-85-screen max-w-screen-sm overflow-y-auto shadow"
  [style.z-index]="((index$ | async) ?? 0) + 50"
  [style.bottom.px]="keyboardOffset"
  [class.bottom-0]="keyboardOffset === 0"
>
  <div class="rounded-t-3xl p-5 md:p-7" [style.backgroundColor]="backgroundColor | contentBuilderColor: '#FFFFFF'">
    <div class="mb-6 flex items-center justify-between">
      <h2 class="font-accent text-3xs font-bold">
        {{ 'como.use-credit-balance.title' | translate }}
      </h2>
      <app-rounded-icon-button
        icon="icon-cross"
        (onClick)="close()"
      ></app-rounded-icon-button>
    </div>

    @if (isDataLoaded) {
      <label
        for="amountToUse"
        class="block font-base text-base font-normal leading-5 text-neutral-600"
      >
        {{ 'como.use-credit-balance.description' | translate }}
      </label>
      <label
        for="amountToUse"
        class="mb-2 block font-base text-xs font-normal text-neutral-500"
      >
        <app-price-atom
          [size]="'SM'"
          [amount]="maxAmountToUse"
          [bold]="false"
          [format]="true"
        ></app-price-atom>
      </label>
      <div class="pb-6 leading-5 text-neutral-800">
        <input
          [(ngModel)]="amountToUse"
          id="amountToUse"
          type="number"
          min="0.00"
          step="0.01"
          class="w-full rounded border border-neutral-800 px-5 py-4.5"
        />
        @if (amountToUse > maxAmountToUse / 100) {
          <div class="pt-2 font-base text-error-600">
            {{ 'como.use-credit-balance.max-info' | translate }}
            <app-price-atom
              [size]="'SM'"
              [amount]="maxAmountToUse"
              [bold]="false"
              [format]="true"
            ></app-price-atom>
          </div>
        }
      </div>
      @if (verificationCodeRequired) {
        <label
          for="amountToUse"
          class="mb-2 block font-base text-base font-normal leading-5 text-neutral-600"
        >
          {{ 'como.use-credit-balance.code' | translate }}
        </label>
        <div class="pb-6 leading-5 text-neutral-800">
          <input
            [(ngModel)]="verificationCode"
            id="verificationCode"
            class="w-full rounded border border-neutral-800 px-5 py-4.5"
          />
        </div>
      }
    } @else {
      @for (i of [].constructor(2); track $index) {
        <div class="mb-3 h-4 w-32 animate-pulse rounded bg-neutral-100"></div>
        <div class="mb-6 h-10 w-full animate-pulse rounded bg-neutral-50"></div>
      }
    }

    <div class="flex flex-nowrap pt-1">
      <div class="w-1/2 pr-1">
        <app-button-atom
          size="M"
          [label]="'como.use-credit-balance.cancel' | translate"
          color="primary"
          (click)="close()"
          type="light"
          [full]="true"
        ></app-button-atom>
      </div>
      <div class="w-1/2 pl-1 pt-0">
        <app-button-atom
          size="M"
          [label]="'como.use-credit-balance.validate' | translate"
          (click)="apply()"
          type="primary"
          [full]="true"
          [iconUrl]="isValidating ? 'assets/images/spinner.svg' : ''"
          [disabled]="!isDataLoaded || isValidating || amountToUse > maxAmountToUse / 100"
        ></app-button-atom>
      </div>
    </div>
  </div>
</div>
